import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';

const GridContainer = function (props: GridProps) {
  return <Grid container spacing={5} {...props} />;
};

export default GridContainer;
